(() => {
  if (window.boldBackToTop) return;
  window.boldBackToTop = true;
  function init() {
    if (!document.querySelector('[data-bold-layout-draft],[data-catalog-layout]')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'bold-back-to-top';
    button.textContent = '↑ Back to top';
    button.hidden = true;
    button.dataset.ihFeature = 'product-navigation';
    button.dataset.ihAction = 'back_to_top';
    button.dataset.ihResource = 'product';
    const mobile = matchMedia('(max-width: 749px)');
    const update = () => {
      const purchase = document.querySelector('product-form button[name="add"]')?.getBoundingClientRect();
      const purchaseVisible = purchase && purchase.top < innerHeight && purchase.bottom > 0;
      button.hidden = scrollY < Math.max(600, innerHeight) || purchaseVisible;
    };
    let scheduled = false;
    addEventListener('scroll', () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; update(); });
    }, { passive: true });
    mobile.addEventListener('change', update);
    button.addEventListener('click', () => {
      const title = document.querySelector('[data-product-layout-header] h1');
      if (title) { title.setAttribute('tabindex', '-1'); title.focus({ preventScroll: true }); }
      window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
    document.body.append(button);
    document.dispatchEvent(new CustomEvent('product-info:loaded'));
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
